/** The language switcher (03 §14.3): in the footer and on `/profile`, each locale under its own name. */
import { LOCALES, type Locale, NATIVE_NAMES, t } from '@tarock/i18n';
import { localeSignal, switchLocale } from './locale';

/** A select of the shipped locales; `compact` is the footer's inline form. */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const current = localeSignal.value;
  return (
    <label class={compact ? 'lang-switch' : 'field'}>
      <span>{t('prefs.language.label')}</span>
      <select
        data-testid={compact ? 'footer-language' : 'profile-language'}
        value={current}
        onChange={(e) => void switchLocale((e.target as HTMLSelectElement).value as Locale)}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l} lang={l}>
            {NATIVE_NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
